export default __webpack_public_path__ + "static/media/soehne-web-buch.d2449f7a.woff2";